export class Hooks {
  /**
   * Solves Shopify's bad hook (TODO: describe)
   */
  static setupFetchHook(): void {
    const originalFetch = window.fetch

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any).fetch = function (resource: RequestInfo | URL, options?: RequestInit) {
      const adaptedResource = resource instanceof URL ? resource.toString() : resource
      return originalFetch(adaptedResource, options)
    }
  }
}
